import { render, staticRenderFns } from "./BaseCheckComponent.vue?vue&type=template&id=00528fb8&"
import script from "./BaseCheckComponent.vue?vue&type=script&lang=js&"
export * from "./BaseCheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00528fb8')) {
      api.createRecord('00528fb8', component.options)
    } else {
      api.reload('00528fb8', component.options)
    }
    module.hot.accept("./BaseCheckComponent.vue?vue&type=template&id=00528fb8&", function () {
      api.rerender('00528fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/BaseCheckComponent.vue"
export default component.exports